import { render, staticRenderFns } from "./CategoriesTab.vue?vue&type=template&id=bc8b5148&scoped=true&"
import script from "./CategoriesTab.vue?vue&type=script&lang=js&"
export * from "./CategoriesTab.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesTab.vue?vue&type=style&index=0&id=bc8b5148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8b5148",
  null
  
)

export default component.exports